export function getClinicPrice(basePrice: number | null | null | undefined) {
    return (basePrice || 0) + 20;
}